const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api";

const getToken = () => localStorage.getItem("accessToken");

// Send interest
export const sendInterest = async (receiverId: number) => {
  const res = await fetch(`${API_BASE_URL}/connection/request`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify({ receiverId }),
  });

  return res.json();
};

// Check access (IMPORTANT)
export const checkProfileAccess = async (userId: number) => {
  const res = await fetch(`${API_BASE_URL}/connection/can-view/${userId}`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });

  return res.json();
};

export const getNotifications = async () => {
  const res = await fetch(`${API_BASE_URL}/connection/notifications`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });

  return res.json();
};

export const getSentRequests = async () => {
  const res = await fetch(`${API_BASE_URL}/connection/all-requests`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });

  return res.json();
};

// Accept / Reject request
export const updateConnectionStatus = async (requestId: number, status: "accepted" | "rejected") => {
  const res = await fetch(`${API_BASE_URL}/connection/request/update-status`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify({ requestId, status }),
  });

  return res.json();
};
